import { render } from "./IconExternalLink.vue?vue&type=template&id=1a75da94"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconExternalLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a75da94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a75da94', __exports__)) {
    api.reload('1a75da94', __exports__)
  }
  
  module.hot.accept("./IconExternalLink.vue?vue&type=template&id=1a75da94", () => {
    api.rerender('1a75da94', render)
  })

}


export default __exports__